export var version = "3.8.6";
//# sourceMappingURL=version.js.map